import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    searchTerm: '',
    customerAddDialog: {
        open: false,
    },
    customerEditDialog: {
        open: false,
        customerId: undefined,
        activeTab: 'general',
    },
    deliveryAddressEditDialog: {
        open: false,
        deliveryAddress: undefined,
    },
    legalAddDialog: {
        open: false,
    },
    legalEditDialog: {
        open: false,
        legal: undefined,
    },
    consigneeEditDialog: {
        open: false,
        customerId: 0,
        consignee: undefined,
    },
    emailNotificationEditDialog: {
        open: false,
        customerEmail: undefined,
    },
    // notificationScheduleEditDialog: {
    // 	open: false,
    // 	customerId: undefined,
    // },
    priceListMarkupEditPopover: {
        open: false,
        markupEditData: {
            top: 0,
            left: 0,
            logo: '',
            customerId: 0,
            priceListId: 0,
            markup: undefined,
        },
    },
    ordersFromFileTab: {
        beingActivatedRules: [],
        beingDeletedRules: [],
    },
    orderImportRuleEdit: {
        pendingEmailsForSendingInputValue: '',
        pendingEmailsForReplyInputValue: '',
    },
};
export const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        openAddCustomerDialog: (state) => {
            state.customerAddDialog.open = true;
        },
        closeAddCustomerDialog: (state) => {
            state.customerAddDialog.open = false;
        },
        openCustomerEditDialog: (state, action) => {
            state.customerEditDialog.open = true;
            state.customerEditDialog.customerId = action.payload.customerId;
            state.customerEditDialog.activeTab = action.payload.tab ? action.payload.tab : 'general';
        },
        closeCustomerEditDialog: (state) => {
            state.customerEditDialog = initialState.customerEditDialog;
        },
        setCustomerEditDialogActiveTab: (state, action) => {
            state.customerEditDialog.activeTab = action.payload;
        },
        openDeliveryAddressEditDialog: (state, action) => {
            state.deliveryAddressEditDialog.open = true;
            state.deliveryAddressEditDialog.deliveryAddress = action.payload.deliveryAddress;
        },
        closeDeliveryAddressEditDialog: (state) => {
            state.deliveryAddressEditDialog.open = false;
            state.deliveryAddressEditDialog.deliveryAddress = undefined;
        },
        openLegalAddDialog: (state) => {
            state.legalAddDialog.open = true;
        },
        closeLegalAddDialog: (state) => {
            state.legalAddDialog.open = false;
        },
        openLegalEditDialog: (state, action) => {
            state.legalEditDialog.open = true;
            state.legalEditDialog.legal = action.payload.legal;
        },
        closeLegalEditDialog: (state) => {
            state.legalEditDialog.open = false;
            state.legalEditDialog.legal = undefined;
        },
        openConsigneeEditDialog: (state, action) => {
            state.consigneeEditDialog = {
                open: true,
                ...action.payload,
            };
        },
        closeConsigneeEditDialog: (state) => {
            state.consigneeEditDialog = initialState.consigneeEditDialog;
        },
        openEmailNotificationEditDialog: (state, action) => {
            state.emailNotificationEditDialog.open = true;
            state.emailNotificationEditDialog.customerEmail = action.payload.customerEmail;
        },
        closeNotificationEmailEditDialog: (state) => {
            state.emailNotificationEditDialog.open = false;
            state.emailNotificationEditDialog.customerEmail = undefined;
        },
        // openNotificationScheduleEditDialog: (state) => {
        // 	state.notificationScheduleEditDialog.open = true;
        // 	state.notificationScheduleEditDialog.customerId = state.customerEditDialog.customerId;
        // },
        // closeNotificationScheduleEditDialog: (state) => {
        // 	state.notificationScheduleEditDialog = initialState.notificationScheduleEditDialog;
        // },
        openPersonalMarkupEditPopover: (state, action) => {
            state.priceListMarkupEditPopover.open = true;
            state.priceListMarkupEditPopover.markupEditData = action.payload;
        },
        closePersonalMarkupEditPopover: (state) => {
            state.priceListMarkupEditPopover = initialState.priceListMarkupEditPopover;
        },
        addRuleToBeingActivated: (state, action) => {
            state.ordersFromFileTab.beingActivatedRules.push(action.payload);
        },
        removeRuleFromBeingActivated: (state, action) => {
            state.ordersFromFileTab.beingActivatedRules = state.ordersFromFileTab.beingActivatedRules.filter((item) => item !== action.payload);
        },
        addRuleToBeingDeleted: (state, action) => {
            state.ordersFromFileTab.beingDeletedRules.push(action.payload);
        },
        removeRuleFromBeingDeleted: (state, action) => {
            state.ordersFromFileTab.beingDeletedRules = state.ordersFromFileTab.beingDeletedRules.filter((item) => item !== action.payload);
        },
        resetOrdersFromFileTabState: (state) => {
            state.ordersFromFileTab = initialState.ordersFromFileTab;
        },
        setPendingEmailsForSendingInputValue: (state, action) => {
            state.orderImportRuleEdit.pendingEmailsForSendingInputValue = action.payload.trim();
        },
        setPendingEmailsForReplyInputValue: (state, action) => {
            state.orderImportRuleEdit.pendingEmailsForReplyInputValue = action.payload.trim();
        },
        resetOrderImportRuleEditState: (state) => {
            state.orderImportRuleEdit = initialState.orderImportRuleEdit;
        },
    },
});
export const { actions: customerActions, reducer: customerReducer } = customerSlice;
